import React from "react";
import LogoBranca from "../assets/LogoBranca1200x600.png"

const Footer = () => {
  return (
    <div className="w-full bg-white flex justify-center h-fit dark:bg-white">
      <img className="max-h-[120px] m-1" src={LogoBranca} alt="/</div>"></img>
      {/* <div className="w-full bg-transparent flex justify-end">
        <div className="flex flex-col justify-center p-2 text-right">
          <h1 className="text-m font-light"><strong>Endereço:</strong> R. Teixeira Soares, 138 - loja 2 - Seminário, Curitiba - PR, 80240-440</h1>
          <h1 className="text-m font-light"><strong>Telefone:</strong> (41) 99263-6949</h1>
          <h1 className="text-m font-light"><strong>Horário de funcionamento:</strong> Seg. a Sex. (08:00-18:00). Sáb (08:00-12:00)</h1>
        </div>
      </div> */}
    </div>
  )
}

export default Footer;